import React from 'react'

// Components
import {
  Button,
  CopyToClipboard,
  Modal,
  ModalInjectedProps,
} from '@sketch/components'

// Local Components
import AccessScope from '../../components/AccessScope'
import Divider from '../../components/Divider'
import TokenDetailsItem from '../../components/TokenDetailsItem'

// Types
import { PersonalTokenFragment } from '@sketch/gql-types'

// Styles
import {
  CopyTokenContainer,
  TokenSecret,
  TokenDetailsRow,
  PermissionsHeading,
  Callout,
} from './CopyTokenModal.styles'

import { dateFormat } from '@sketch/utils'

type CopyTokenModalProps = {
  token: PersonalTokenFragment
  secret: string
} & ModalInjectedProps

const CopyTokenModal: React.FC<CopyTokenModalProps> = props => {
  const { hideModal, token, secret } = props
  const tokenValue = btoa(`${token.identifier}:${secret}`)
  const expiresAt = token.expiresAt
    ? dateFormat(new Date(token.expiresAt))
    : 'Never'

  return (
    <Modal title="Token Details" onCancel={hideModal}>
      <Modal.Body>
        <div>
          Tokens are linked to your account. You’ll only see this token once, so
          copy and store it in a safe place.
        </div>
        <CopyTokenContainer>
          <TokenSecret data-testid="token-secret">{tokenValue}</TokenSecret>
          <CopyToClipboard title="Copy" value={tokenValue} showIcon={false} />
        </CopyTokenContainer>
        <Divider />
        <TokenDetailsRow>
          <TokenDetailsItem>
            <span>DESCRIPTION</span>
            <span>{token.description}</span>
          </TokenDetailsItem>
          <TokenDetailsItem>
            <span>EXPIRES ON</span>
            <span>{expiresAt}</span>
          </TokenDetailsItem>
        </TokenDetailsRow>
        <PermissionsHeading>PERMISSIONS</PermissionsHeading>
        {token.accessScopes.map(scope => (
          <AccessScope key={scope} scope={scope} enabled={true} />
        ))}
        <Callout>
          <div>Before you go...</div>
          <div>
            Make sure you copy and store this token now — you won’t be able to
            retrieve it after you close this dialog.
          </div>
        </Callout>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={hideModal}>
          Finish
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CopyTokenModal
